var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class PageTeam extends Component {
    constructor() {
        super('PageTeam', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.page-team__person-thumbnail').on('mouseenter', (event, thumbnail) => {
                $('.page-team__person').removeClass('is-active');
                $(`.page-team__person[data-id="${thumbnail.data('id')}"]`).addClass('is-active');
            }).on('mouseleave', (event, thumbnail) => {
                $('.page-team__person').removeClass('is-active');
            }).on('click', (event, thumbnail) => {
                window.open($(`.page-team__person[data-id="${thumbnail.data('id')}"]`).attr('href'), '_blank');
            });
            this.success();
        });
    }
}
